import { gql } from '@apollo/client';

export const GET_PRICING_TARGETS = gql`
  query getPricingTargets(
    $pricingType: PricingInfoType!
    $countryCode: CountryCode!
    $withPredefinedTickets: Boolean
  ) {
    getPricingTargets(
      pricingType: $pricingType
      countryCode: $countryCode
      withPredefinedTickets: $withPredefinedTickets
    ) {
      parkingZoneUids
      customerSegments {
        segmentName
        segmentUid
      }
    }
  }
`;
